import { InitialConfigType } from '@lexical/react/LexicalComposer';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ParagraphNode, RangeSelection } from 'lexical';
import { ListItemNode, ListNode } from '@lexical/list';
import { $convertFromMarkdownString, TRANSFORMERS } from '@lexical/markdown';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { CodeNode, CodeHighlightNode } from '@lexical/code';
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table';
import { $isAtNodeEnd } from '@lexical/selection';

export const richTextEditorConfig: InitialConfigType = {
  editorState: () => $convertFromMarkdownString('', TRANSFORMERS),
  namespace: 'richt-text-editor',
  nodes: [
    ParagraphNode,
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    CodeNode,
    CodeHighlightNode,
    TableNode,
    TableCellNode,
    TableRowNode,
    AutoLinkNode,
    LinkNode,
  ],
  onError(error: Error) {
    throw error;
  },
  theme: {
    link: 'text-info300 underline',
    list: {
      ul: 'list-disc list-inside',
      ol: 'list-decimal list-inside',
      listitem: 'editor-listitem',
      nested: {
        list: '',
        listitem: 'ml-24 !list-none',
      },
    },
    ltr: 'ltr',
    paragraph:
      'text-grayscale600 text-xs md:text-sm leading-1 md:leading-2 font-extralight',
    rtl: 'rtl',
    text: {
      bold: 'font-semibold',
      italic: 'italic',
      overflowed: 'editor-text-overflowed',
      strikethrough: 'line-through',
      underline: 'underline',
      underlineStrikethrough: 'underline line-through',
    },
  },
};

export function getSelectedNode(selection: RangeSelection) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = selection.anchor.getNode();
  const focusNode = selection.focus.getNode();
  if (anchorNode === focusNode) {
    return anchorNode;
  }
  const isBackward = selection.isBackward();
  if (isBackward) {
    return $isAtNodeEnd(focus) ? anchorNode : focusNode;
  } else {
    return $isAtNodeEnd(anchor) ? focusNode : anchorNode;
  }
}
